import React, { useState } from "react";
import { ReactComponent as UnlockIcon } from "../../../../../Assets/Icons/unlockIcon.svg";
import styles from "./UnLockIconStyles.module.css";
import UnlockConfirmationDialog from "../EscalationIcons/UnlockConfirmationDialog";
import { useInsightsUtils } from "../../../../../hooks/useInsightsUtils";

interface lockIconProps{
    record: Record<string, any>;
}

export const UnLockIcon: React.FC<lockIconProps> = (props) => {
    const { UnLockApplication } = useInsightsUtils();

    const {record} = props;
    const oppId = record.opportunityUid;
    const check = (record.firstName === null || record.lastName === null)
    const fullName =check ? null :  record.firstName +" "+record.lastName;

    const [open, setOpen] = useState(false);

    const handleUnlockClick = () => {
        setOpen(true);
    };

    const handleConfirm = async () => {
        await UnLockApplication(oppId);
        setOpen(false);
    };

    const handleClose = () => {
        setOpen(false);
    };



    return (
        <>
        <span className={styles.outerCtn}>
            <UnlockIcon onClick={handleUnlockClick}/>
        </span>
        <UnlockConfirmationDialog
            open={open}
            onClose={handleClose}
            onConfirm={handleConfirm}
            userName={fullName}
            opportunityId={oppId}
        />
        </>
    );
};